import { render, staticRenderFns } from "./DefaultContentLayoutNew.vue?vue&type=template&id=d5473756"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5473756')) {
      api.createRecord('d5473756', component.options)
    } else {
      api.reload('d5473756', component.options)
    }
    module.hot.accept("./DefaultContentLayoutNew.vue?vue&type=template&id=d5473756", function () {
      api.rerender('d5473756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scaffold/DefaultContentLayoutNew.vue"
export default component.exports